import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { SiteHeaderComponent } from './_layouts/site-header/site-header.component';
import { SiteFooterComponent } from './_layouts/site-footer/site-footer.component';
import { SpinnerComponent } from './_layouts/spinner/spinner.component';
import { SidebarComponent } from './_layouts/sidebar/sidebar.component';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HomeModule } from './home/home.module';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ErrorInterceptor, JwtInterceptor } from './_helpers';
import { SetupDoctorsComponent } from './setup-doctors/setup-doctors.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { PreAuthDischargeComponent } from './pre-auth-discharge/pre-auth-discharge.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { RouterModule } from '@angular/router';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NewAdmissionComponent } from './new-admission/new-admission.component';

@NgModule({
  imports: [
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        AppRoutingModule,HomeModule,
        DatePipe,
        FormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        }),
        NgxPaginationModule,
        NgApexchartsModule,
        NgxDaterangepickerMd.forRoot()
  ],
  declarations: [
    AppComponent,
    PreAuthDischargeComponent,
    //NewAdmissionComponent,
    //SiteHeaderComponent,
    //SiteFooterComponent,
    //SpinnerComponent,
    //SidebarComponent,
    //HomeComponent,
    //DashboardComponent,
    //LoginComponent
  ],
  providers: [ 
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
